export default "__VITE_ASSET__B6gl9En8__"